var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waiting-layer"},[_c('div',[_c('img',{staticClass:"waiting",attrs:{"src":require("../../assets/neo-spinner.svg"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }